<template>
  <v-container>
    <v-row justify="center" align="center">
      <v-col cols="12" xl="6" lg="6">
        <v-text-field
          prepend-inner-icon="mdi-magnify"
          v-model="search"
          label="Buscar..."
          clearable
        >
        </v-text-field>
      </v-col>
      <v-col cols="12" xl="6" lg="6">
        <v-btn
          small
          color="primary"
          rounded
          @click="fetchData()"
          fab
          class="mx-1"
          ><v-icon>mdi-refresh</v-icon></v-btn
        >

        <v-btn
          small
          color="primary"
          rounded
          @click="generateReport()"
          fab
          class="mx-1"
          ><v-icon>mdi-file-chart-outline</v-icon></v-btn
        >
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-data-table
          fixed-header
          height="auto"
          :headers="headers"
          :items="summaryMo"
          :items-per-page="10"
          no-data-text="No hay microorganismos"
          loading-text="Cargando microorganismos..."
          :page.sync="page"
          hide-default-footer
          :loading="fetchingData"
          @click:row="rowSelect"
          :item-class="row_classes"
        >
          <!-- <template #[`item.isActive`]="{ item }">
            <span v-if="item.isActive" class="rounded-orange"> Activo </span>
            <span v-else class="rounded-green"> Disponible </span>
          </template>
          <template #[`item.lote`]="{ item }">
            <span v-if="item.lote">
              {{ item.lote.loteId }}
            </span>
            <span v-else> - </span>
          </template> -->
        </v-data-table>
        <v-pagination
          v-model="page"
          :length="numPages"
          total-visible="10"
          color="primary"
        ></v-pagination>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// vuex
import { mapActions, mapMutations } from "vuex";

export default {
  data: () => ({
    page: 1,
    numPages: 1,
    headers: [
      {
        text: "Microorganismo",
        align: "center",
        value: "name",
        sortable: false,
      },
      {
        text: "Arroz en incubación (dosis)",
        align: "center",
        value: "dosesRaiz",
        sortable: false,
      },
      {
        text: "Secado (dosis)",
        align: "center",
        value: "dosesDry",
        sortable: false,
      },
      {
        text: "Espora (dosis)",
        align: "center",
        value: "dosesSpore",
        sortable: false,
      },
      {
        text: "Semi terminado (dosis)",
        align: "center",
        value: "isActive",
        sortable: false,
      },
      {
        text: "Dosis totales (basado en 500g)",
        align: "center",
        value: "dosesTotal",
        sortable: false,
      },
    ],
    summaryMo: [],
    fetchingData: false,
    search: null,
  }),
  async created() {
    await this.fetchData();
  },
  methods: {
    ...mapActions("lotes", ["getSummaryMo"]),
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    rowSelect(rowValue) {
      this.hoppers = this.hoppers.map((data) => {
        if (rowValue._id == data._id) {
          data.clicked = true;
        } else {
          data.clicked = false;
        }
        return data;
      });
    },
    row_classes(value) {
      if (value.clicked) {
        return "custom-highlight-row";
      }
    },
    async fetchData() {
      try {
        this.fetchingData = true;
        let response = await this.getSummaryMo({
          page: this.page,
          search: this.search,
        });
        if (response) {
          this.summaryMo = response.summaryMo;
          this.numPages = response.pages;
        } else {
          this.SET_ALERT_TYPE({
            visible: true,
            type: "error",
            text: "Error al cargar tolvas",
            timeout: 3500,
          });
        }
      } catch (error) {
        console.log(error);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: "Error al cargar tolvas",
          timeout: 3500,
        });
      }
      this.fetchingData = false;
    },
    async generateReport() {},
  },
  watch: {
    async page() {
      await this.fetchData();
    },
    async search() {
      this.page = 1;
      await this.fetchData();
    },
  },
};
</script>

<style scoped></style>
